export enum InputType {
  static = "static",
  text = "text",
  select = "select",
  usCurrency = "usCurrency",
  number = "number",
  address = "address",
}
